module.exports = __webpack_public_path__ + "static/media/view6_bg1.36a6e115.jpg";